/*
 * File: /src/store/modules/dialDestinations.js
 * Created Date: Sunday November 15th 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 15th November 2020 11:44:26 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */
import dialDestinationService from 'src/services/dialDestinationService';

const state = {
  dialDestinations: undefined
};
const getters = {
  getDialDestinations: state => state.dialDestinations
};
const actions = {
  async fetchDialDestinations({ commit }) {
    if (state.dialDestinations == undefined) {
      return dialDestinationService.fetchUserDialDestinations()
        .then(r => {
          let dd = [];
          for (const inc in r.data) {
            dd.push(Object.assign({}, r.data[inc]));
          }
          const result = Object.assign([], dd);
          commit('storeDialDestinations', result);
        });
    }
  },
  unloadDialDestinations({ commit }) {
    commit('storeDialDestinations', undefined);
  },
};
const mutations = {
  storeDialDestinations(state, dd) {
    state.dialDestinations = Object.assign([], dd);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
